import { useEffect, useState } from "react";

import { Spinner } from "@/components/ui/spinner";
import { transitionFromAppSplash } from "@/lib/ui-helper/app-splash";
import { cn } from "@/lib/utils";

export function AuthStatusCheckView() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      transitionFromAppSplash();
      setVisible(true);
    });

    return () => {
      cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <div
      className={cn(
        "flex min-h-screen items-center justify-center bg-background p-6 transition-opacity duration-300 ease-out",
        visible ? "opacity-100" : "opacity-0"
      )}>
      <div
        className="flex flex-col items-center gap-4 text-center"
        role="status"
        aria-live="polite">
        <Spinner className="h-10 w-10 text-primary" />
        <p className="text-sm text-muted-foreground">
          Vérification de votre statut d&apos;authentification...
        </p>
      </div>
    </div>
  );
}
